import React from "react";
import { Link } from "react-router-dom";

import logo from "../assets/images/lcbtp.png";

//import Components
import SearchOption from "../Components/Common/SearchOption";
import LanguageDropdown from "../Components/Common/LanguageDropdown";
import FullScreenDropdown from "../Components/Common/FullScreenDropdown";
import ProfileDropdown from "../Components/Common/ProfileDropdown";
import LightDark from "../Components/Common/LightDark";

const headerLogoSm = {
  display: "block",
  height: 22,
  width: "auto",
  maxWidth: 140,
  objectFit: "contain",
};

const headerLogoLg = {
  display: "block",
  height: 34,
  width: "auto",
  maxWidth: 200,
  objectFit: "contain",
};

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
  return (
    <React.Fragment>
      <header
        id="page-topbar"
        className={`${headerClass} lcbtp-header-topbar`.trim()}
      >
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logo} alt="LCBTP" style={headerLogoSm} />
                  </span>
                  <span className="logo-lg">
                    <img src={logo} alt="LCBTP" style={headerLogoLg} />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logo} alt="LCBTP" style={headerLogoSm} />
                  </span>
                  <span className="logo-lg">
                    <img src={logo} alt="LCBTP" style={headerLogoLg} />
                  </span>
                </Link>
              </div>
              <SearchOption />
            </div>
            <div className="d-flex align-items-center">
              <LanguageDropdown />
              <FullScreenDropdown />
              <LightDark
                layoutMode={layoutModeType}
                onChangeLayoutMode={onChangeLayoutMode}
              />
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
